import styles from '../Prompt.module.less'

type PromptStringContentPropsType = {
    content: string
    id: string
}

export const PromptStringContent = (props: PromptStringContentPropsType) => {
    return (
        <div className={styles['text-content']} id={props.id}>
            {props.content}
        </div>
    )
}
